module.exports = __webpack_public_path__ + "img/arrow-white.a009e1fc.svg";